module.exports = __webpack_public_path__ + "img/summary-background-maritime.7fd0b830.svg";